var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7069 0.0667529C9.92742 0.147961 10.1585 0.34547 10.5446 0.782891C10.9241 1.21277 10.9835 1.34111 10.9847 1.73398C10.9855 1.96216 10.9669 2.08882 10.9159 2.20294C10.8687 2.30872 9.6897 3.59371 7.26722 6.17951L3.68828 9.99976L7.26931 13.8196C9.23888 15.9206 10.8793 17.701 10.9148 17.7763C10.9502 17.8515 10.9869 18.0386 10.9962 18.192C11.0224 18.6216 10.9225 18.8167 10.3877 19.3819C10.0294 19.7605 9.92401 19.8488 9.74662 19.9194C9.49427 20.0198 9.3266 20.0253 9.0579 19.9422C8.86334 19.882 8.75758 19.773 4.5183 15.2624C1.01051 11.53 0.161119 10.6067 0.0903759 10.4488C0.0258675 10.3048 0.00283623 10.1865 0.00283623 9.99937C0.00283623 9.48418 -0.268141 9.80213 4.48706 4.73773C8.60546 0.351528 8.79421 0.156519 8.9976 0.0774607C9.25432 -0.0223883 9.45664 -0.0254365 9.7069 0.0667529Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.b91393d02f98b0cc17f131adcba11601.svg";
export { ForwardRef as ReactComponent };